import * as api from "../api/produto";
import { START_PROGRESS, STOP_PROGRESS } from "./progress";
import { showNotification } from "./notification";

export const LOAD_PRODUTOS_SUCCESS = "LOAD_PRODUTOS_SUCCESS";
export const LOAD_PRODUTOS_FAIL = "LOAD_PRODUTOS_FAIL";
export const LOAD_PRODUTO_SUCCESS = "LOAD_PRODUTO_SUCCESS";
export const LOAD_PRODUTO_FAIL = "LOAD_PRODUTO_FAIL";
export const CREATE_PRODUTO_SUCCESS = "CREATE_PRODUTO_SUCCESS";
export const CREATE_PRODUTO_FAIL = "CREATE_PRODUTO_FAIL";
export const UPDATE_PRODUTO_SUCCESS = "UPDATE_PRODUTO_SUCCESS";
export const UPDATE_PRODUTO_FAIL = "UPDATE_PRODUTO_FAIL";
export const DELETE_PRODUTO_SUCCESS = "DELETE_PRODUTO_SUCCESS";
export const DELETE_PRODUTO_FAIL = "DELETE_PRODUTO_FAIL";

export const loadProdutos = (lojaId) => async (dispatch) => {
  try {
    dispatch({ type: START_PROGRESS });
    const { data } = await api.getProdutos(lojaId);
    dispatch({ type: LOAD_PRODUTOS_SUCCESS, payload: data });
  } catch (error) {
    console.error("Erro ao carregar produtos:", error);
    dispatch({ type: LOAD_PRODUTOS_FAIL, payload: error.message });
  } finally {
    dispatch({ type: STOP_PROGRESS });
  }
};

export const loadProdutoById = (produtoId, lojaId) => async (dispatch) => {
  try {
    dispatch({ type: START_PROGRESS });
    const { data } = await api.getProdutoById(produtoId, lojaId);
    dispatch({ type: LOAD_PRODUTO_SUCCESS, payload: data });
  } catch (error) {
    console.error("Erro ao carregar produto:", error);
    dispatch({ type: LOAD_PRODUTO_FAIL, payload: error.message });
  } finally {
    dispatch({ type: STOP_PROGRESS });
  }
};

export const criarProdutoAction = (produtoData) => async (dispatch) => {
  try {
    dispatch({ type: START_PROGRESS });
    const { data } = await api.criarProduto(produtoData);
    dispatch({ type: CREATE_PRODUTO_SUCCESS, payload: data });
    dispatch(
      showNotification({
        message: data?.message || "Produto criado com sucesso!",
        color: data?.type || "success",
      })
    );
    return data;
  } catch (error) {
    console.error("Erro ao criar produto:", error);
    dispatch({ type: CREATE_PRODUTO_FAIL, payload: error.message });
    dispatch(
      showNotification({
        message: error?.message || "Erro ao criar produto.",
        color: error?.type || "failure",
      })
    );
    throw error;
  } finally {
    dispatch({ type: STOP_PROGRESS });
  }
};

export const atualizarProdutoAction =
  (produtoId, lojaId, produtoData) => async (dispatch) => {
    try {
      dispatch({ type: START_PROGRESS });

      const payload = { ...produtoData, lojaId };

      const { data } = await api.atualizarProduto(produtoId, payload);
      dispatch({ type: UPDATE_PRODUTO_SUCCESS, payload: data });
      dispatch(
        showNotification({
          message: data?.message || "Produto atualizado com sucesso!",
          color: data?.type || "success",
        })
      );
    } catch (error) {
      console.error("Erro ao atualizar produto:", error);
      dispatch({ type: UPDATE_PRODUTO_FAIL, payload: error.message });
      dispatch(
        showNotification({
          message: error?.message || "Erro ao atualizar produto.",
          color: error?.type || "failure",
        })
      );
      throw error;
    } finally {
      dispatch({ type: STOP_PROGRESS });
    }
  };

export const deletarProdutoAction = (produtoId, lojaId) => async (dispatch) => {
  try {
    dispatch({ type: START_PROGRESS });
    const { data } = await api.deletarProduto(produtoId, lojaId);
    dispatch({ type: DELETE_PRODUTO_SUCCESS, payload: produtoId });
    dispatch(
      showNotification({
        message: data?.message || "Produto deletado com sucesso!",
        color: data?.type || "success",
      })
    );
  } catch (error) {
    console.error("Erro ao deletar produto:", error);
    dispatch({ type: DELETE_PRODUTO_FAIL, payload: error.message });
    dispatch(
      showNotification({
        message: error?.message || "Erro ao deletar produto.",
        color: error?.type || "failure",
      })
    );
  } finally {
    dispatch({ type: STOP_PROGRESS });
  }
};
